import { render, staticRenderFns } from "./MonitorPage.vue?vue&type=template&id=5208f3e0&scoped=true&"
import script from "./MonitorPage.vue?vue&type=script&lang=js&"
export * from "./MonitorPage.vue?vue&type=script&lang=js&"
import style0 from "./MonitorPage.vue?vue&type=style&index=0&id=5208f3e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208f3e0",
  null
  
)

export default component.exports